export enum TrendDataScale {
  MONTH,
  DAY,
  HOUR,
  MINUTE,
  SECONDS,
}
